import { EventDispatcher } from './event-dispatcher';

export class Base<Events extends {} = {}> {
	events: Events

	constructor() {
		this.events = this.defineEvents()
	}

	get className(): string {
		return this.constructor.name
	}

	protected defineEvents(): Events {
		return new Proxy<Events>({} as Events, {
            get: (target: any, property: string, receiver: any) => {
                if(!target.hasOwnProperty(property)){
                    Reflect.set(target, property, new EventDispatcher(property, this), receiver)
                }
                return Reflect.get(target, property, receiver)
            }
        })
	}
}
